import React, {Suspense, useEffect, useMemo} from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './i18n';
import {Provider, useDispatch, useSelector} from 'react-redux'
import store from './redux/store'
import {FullPageLoader} from "./components/components";
import {useTranslation} from "react-i18next";
import { ToastContainer } from "./components/ToastContainer";
import { Publisher } from './pages/publisher/Publisher';
import CmpConfiguration from "./routes/publisher/CmpConfiguration";
import Users from "./routes/publisher/Users";
import Searchbar from "./components/Searchbar";
import {setNavbarSmall} from "./redux/layoutSlice";
import Documentation from "./pages/publisher/Documentation";
import SdkConfiguration from "./pages/publisher/SdkConfiguration";
import Credentials from "./pages/publisher/Credentials";
import Navigation from "./components/navigation/Navigation";
import Navitem from "./components/navigation/Navitem";
import NavitemGroup from "./components/navigation/NavitemGroup";
import { useGetCurrentUserQuery } from './api/userApiSlice';
import OauthPublisherApplication from './components/oauth/OauthPublisherApplication';
import CmpRequestAccess from './pages/publisher/cmp/CmpRequestAccess';
import NoMenuRoute from './components/navigation/NoMenuRoute';
import Apps from './routes/publisher/Apps';
import UnderMaintenance from './components/errors/UnderMaintenance';
import Devices from './routes/publisher/Devices';

function PublisherDashboard(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navbarSmall = useSelector(state => state.layout.navbarSmall)
  const { data: {withApi, isAdmin, canConfigureCmp, hasDevicesView} = {}, isSuccess: isCurrentUserSuccess } = useGetCurrentUserQuery()

  const toggleNavbar = () => dispatch(setNavbarSmall(!navbarSmall))

  return (
    <Router>
      <div className="background-container"/>
      <FullPageLoader/>
      <ToastContainer/>
      <div className={navbarSmall ? 'nav-sm' : 'nav-md'}>
        <Suspense fallback={<div>{t('loading')}...</div>}>
          <Searchbar handleOnClick={toggleNavbar} />
          <Navigation>
            <Navitem exact path="/" icon='home' text={t('menu.dashboard')} component={Publisher}/>
            { isAdmin && <Navitem path="/users" icon='users' text={t('menu.users')} component={Users}/>}
            { canConfigureCmp &&
              <NavitemGroup icon='consent' text= {t('menu.cmp')}>
                <Navitem path="/cmp/configuration" text={t('menu.cmp_configuration')} component={CmpConfiguration}/>
                <Navitem path="/cmp/analytics" text={t('menu.cmp_analytics')} component={UnderMaintenance}/>
              </NavitemGroup>
            }
            { !canConfigureCmp &&
              <Navitem exact path="/cmp/request_access" icon='consent' text={t('menu.cmp')} component={CmpRequestAccess}/>
            }
            <NavitemGroup icon='code' text= {t('menu.sdk')}>
              <Navitem path="/sdk/documentation" text={t('menu.sdk_documentation')} component={Documentation}/>
              <Navitem path="/sdk/configuration" text={t('menu.sdk_configuration')} component={SdkConfiguration}/>
              <Navitem path="/sdk/credentials" text={t('menu.sdk_credentials')} component={Credentials}/>
              {/*<Navitem path="/devices" text={t('menu.devices')} component={Devices}/>*/}
            </NavitemGroup>
            { withApi && <Navitem path="/api/applications" icon='api' text={t('menu.api')} component={OauthPublisherApplication}/> }
            {hasDevicesView && <Navitem path="/devices" icon='mobile' text={t('menu.devices')} component={Devices}/>}
            <NoMenuRoute path="/apps" icon='device' text={t('menu.devices')}  component={Apps} />
          </Navigation>
        </Suspense>
      </div>
    </Router>
  )
}


document.addEventListener('turbo:load', () => {
	const app = document.getElementById('publisher-app');
	if(app) {
		ReactDOM.render(
      <Provider store={store}>
        <PublisherDashboard />
      </Provider>,
      app
    );
	}
})
